import React from "react";
import logger from "logger";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getStyleJSON } from "Utils/Common";

export default function(props) {
  const { label, taskConfig, param, setValue } = props;

  const toggleBooValue = (key) => {
    let value = !taskConfig[key];
    setValue({ target: { value } }, param);
  };

  return (
    <div style={getStyleJSON("padding-left: 0px; padding-right: 0px; ")}>
      <FormControlLabel
        control={
          <Checkbox
            checked={taskConfig[param]}
            onChange={() => {
              toggleBooValue(param);
            }}
            style={{ paddingLeft: "0px" }}
          />
        }
        label={label}
        style={{
          width: "100%",
          marginLeft: "0px",
          paddingLeft: "0px",
        }}
      />
    </div>
  );
}
